import { Mote } from './mote';
import { MoteEventType, MoteEventOptions, PointOptions, UnlockOptions } from './mote-event-type';

export interface MoteEvent {
    type: MoteEventType;
    mote?: Mote;
    options?: MoteEventOptions;
}

export interface QuizPointMoteEvent {
    type: MoteEventType.QUIZ_POINT;
    mote: Mote;
    options: PointOptions;
}

export interface UnlockMoteEvent {
    type: MoteEventType.UNLOCK_DONE;
    mote: Mote;
    options: UnlockOptions;
}
